import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { FlashPoolsAdminComponent } from '../flash-pools-admin/flash-pools-admin.component';

@Component({
  selector: 'app-flash-activated-home',
  standalone: true,
  imports: [
    MatTabsModule,
    FlashPoolsAdminComponent  
  ],
  templateUrl: './flash-activated-home.component.html',
  styleUrl: './flash-activated-home.component.scss'
})
export class FlashActivatedHomeComponent {

}
